<template>
  <div style="padding-top: 100px">
    <div v-if="!register" style="width: 650px;height: 800px;background-color: white;margin: auto;padding: 50px;display: flex;flex-wrap: wrap;align-items: center;align-content: center;justify-content: center;text-align: center">
      <img style="height: 110px;width: 110px;margin: 24px;" mode="aspectFill" src="../assets/img/register_success.png"/>
      <div style="width: 650px;font-size: 24px;font-weight: 500">Your account was created successfully! Enjoy our plantPP!</div>
      <el-button @click="goHome" style="width: 200px;height:40px;background-color: #FB9348;color: white;margin-top: 40px">View homepage</el-button>
    </div>
    <div v-else style="width: 650px;background-color: white;margin: auto;padding: 50px">
      <div style="text-align: center;font-size: 36px;font-weight: 500">Register</div>
      <el-form :model="form" :rules="rules" ref="ruleForm" label-position="top">
        <el-form-item label="Name" prop="username">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <div style="display: flex;justify-content: space-between">
          <el-form-item label="Email" prop="email">
            <el-input v-model="form.email" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="Email Verification" prop="code">
            <div style="display: flex">
              <el-input style="width: 100px" v-model="form.code"></el-input>
              <el-button @click="seedCodeHandle" style="width: 150px;margin-left: 10px">Send verification code</el-button>
            </div>
          </el-form-item>
        </div>
        <el-form-item label="Cell Phone" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="Organization" prop="unitName">
          <el-input v-model="form.unitName"></el-input>
        </el-form-item>
        <el-form-item label="Title" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="Address" prop="address">
          <el-input v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input type="password" v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="Confirm Password" prop="password2">
          <el-input type="password" v-model="form.password2"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :loading="loading" style="width: 100%;background-color: #FB9348;color: white;height: 40px;margin-top: 40px" @click="submitForm()">submit</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading:false,
      lang:'CN',
      register:true,
      form:{
        username:'',
        email:'',
        phone:'',
        unitName:'',
        topicName:'',
        title:'',
        address:'',
        password:'',
        password2:'',
      },
      rules: {
        username: [
          { required: true, message: 'Please enter your name', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Please enter your email', trigger: 'blur' }
        ],
        code: [
          { required: true, message: 'Please enter verification code', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'Please enter your cell phone', trigger: 'blur' }
        ],
        unitName: [
          { required: true, message: 'Please enter your name of your organization', trigger: 'blur' }
        ],
        topicName: [
          { required: true, message: 'Please enter your department', trigger: 'blur' }

        ],
        title: [
          { required: true, message: 'Please enter your professional title', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'Please enter your address', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please enter your password', trigger: 'blur' }
        ],
        password2: [
          { required: true, message: 'Please confirm your password', trigger: 'blur' }
        ],
      }
    }
  },
  mounted() {
    this.lang = "CN"
  },
  methods: {
    submitForm() {
      if (this.loading) {
        return
      }
      if (this.form.password !== this.form.password2) {
        this.$message.error('Passwords are inconsistent');
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$http.post("/gene/user",this.form)
              .then(res => {
                this.loading = false
                if (res.data.code === 500) {
                  this.$message.error(res.data.msg);
                }else {
                  this.$message.success('Register Success');
                  // this.register = false

                  this.setLocalStorage('login',true)
                  localStorage.setItem("userId",res.data.data.userId);

                  this.$router.push({
                    path: `/account`,
                  })
                }
              })
        } else {
          return false;
        }
      });
    },
    setLocalStorage(key, value) {
      localStorage.setItem(key, value)
      // 手动触发事件
      window.dispatchEvent(new StorageEvent('storage', {
        key: key,
        newValue: value,
        oldValue: localStorage.getItem(key),
        storageArea: localStorage,
        url: window.location.href
      }))
    },
    goHome(){
      this.$router.push({
        path: `/`,
      })
    },
    seedCodeHandle(){
      if (!this.form.email) {
        this.$message.error('Please enter your Email');
        return
      }
      this.$http.post("/gene/user/seedCode",{email:this.form.email})
          .then(res => {
            if (res.data.code === 500) {
              this.$message.error(res.data.msg);
            }else {
              this.$message.success('Verification code Send Success and will be expire in 2min.');
            }
          });
    }
  }
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
html,
body {
  background-color: red;
}

/deep/ .el-form-item__label {
  padding: 0px;
  margin-top: 10px;
}
</style>
